import { render, staticRenderFns } from "./GlanceOptionsItem.vue?vue&type=template&id=af5c8da8&scoped=true&"
import script from "./GlanceOptionsItem.vue?vue&type=script&lang=js&"
export * from "./GlanceOptionsItem.vue?vue&type=script&lang=js&"
import style0 from "./GlanceOptionsItem.vue?vue&type=style&index=0&id=af5c8da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c8da8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardSubtitle,VImg})
